import { Main } from '@/components/layout/main';
import { TasksDialogs } from './components/tasks-dialogs';
import { TasksPrimaryButtons } from './components/tasks-primary-buttons';
import TasksProvider from './context/tasks-context';


export default function Transmissions() {
  return (
    <TasksProvider>
      <Main>
        <div className='flex flex-wrap items-center justify-between mb-2 space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Transmissões</h2>
            <p className='text-muted-foreground'>
              Aqui você gerencia as transmissões cadastradas.
            </p>
          </div>
          <TasksPrimaryButtons />
        </div>
        <div className='flex-1 px-4 py-1 -mx-4 overflow-auto lg:flex-row lg:space-x-12 lg:space-y-0'>
          {/* <DataTable data={tasks} columns={columns} /> */}
          
        </div>
      </Main>

      <TasksDialogs />
    </TasksProvider>
  )
}
